// Política de Privacidad, Política de Cookies y banner de cookies en español.
// Cada sección: { title, paragraphs?: [...], items?: [...] }. Los textos admiten <b>…</b>.
const legal = {
  updated: "Última actualización: 21 de octubre de 2026",
  backToTop: "Volver arriba",

  privacy: {
    title: "Política de Privacidad",
    intro:
      "Esta política explica cómo Qapex S.R.L. trata los datos personales de los usuarios que visitan qapex.it y utilizan sus servicios, conforme a los artículos 13 y 14 del Reglamento (UE) 2016/679 (\"RGPD\") y al Decreto Legislativo italiano 196/2003, modificado por el Decreto Legislativo 101/2018.",
    sections: [
      {
        title: "1. Responsable del tratamiento",
        paragraphs: [
          "<b>Qapex S.R.L.</b> – NIF-IVA IT03818350542 – Via della Louvière, n. 1/A, 06034 Foligno (PG), Italia.",
          "Para cualquier solicitud sobre tus datos personales, escríbenos a <b>info@qapex.it</b>.",
        ],
      },
      {
        title: "2. Datos que tratamos",
        items: [
          "<b>Datos de navegación</b>: dirección IP, tipo de navegador y dispositivo, páginas visitadas, fecha y hora de la solicitud. Los recogen automáticamente los sistemas que hacen funcionar el sitio.",
          "<b>Datos facilitados mediante el formulario de contacto</b>: nombre, apellidos, email, teléfono y el contenido del mensaje.",
          "<b>Datos de las candidaturas</b>: nombre, email, puesto al que te postulas y currículum, con los datos que contiene.",
          "<b>Datos recogidos mediante cookies y herramientas de seguimiento</b>, solo si has dado tu consentimiento. Encontrarás los detalles en la Política de Cookies.",
        ],
      },
      {
        title: "3. Finalidades y bases jurídicas",
        items: [
          "<b>Responder a tus solicitudes de contacto e información</b>: medidas precontractuales adoptadas a petición tuya (art. 6.1.b RGPD).",
          "<b>Evaluar candidaturas y seleccionar personal</b>: medidas precontractuales a petición tuya (art. 6.1.b) y, para los datos del CV, consentimiento (art. 6.1.a y art. 9.2.a para posibles categorías especiales de datos).",
          "<b>Garantizar el funcionamiento y la seguridad del sitio</b>: interés legítimo del responsable (art. 6.1.f).",
          "<b>Medir las visitas al sitio (Google Analytics) y la eficacia de las campañas publicitarias (Meta Pixel)</b>: consentimiento (art. 6.1.a), que puedes retirar en cualquier momento.",
          "<b>Cumplir obligaciones legales y proteger los derechos del responsable</b>: obligación legal (art. 6.1.c) e interés legítimo (art. 6.1.f).",
        ],
      },
      {
        title: "4. Carácter de la comunicación de datos",
        paragraphs: [
          "Facilitar los datos solicitados en los formularios es opcional, pero sin ellos no podemos responder a tu solicitud ni evaluar tu candidatura. El consentimiento a las cookies de medición y marketing es opcional y rechazarlo no limita la navegación.",
        ],
      },
      {
        title: "5. Modo de tratamiento y destinatarios",
        paragraphs: [
          "Los datos se tratan con medios electrónicos y con medidas de seguridad adecuadas. Pueden acceder a ellos el personal autorizado del responsable y los proveedores que prestan servicios por nuestra cuenta, designados encargados del tratamiento (art. 28 RGPD), entre ellos:",
        ],
        items: [
          "el proveedor de alojamiento del sitio;",
          "Google LLC / Google Ireland Ltd (Google Workspace y Apps Script para recibir los mensajes del formulario de contacto; Google Fonts para las tipografías);",
          "FormSubmit (formsubmit.co) para reenviar las candidaturas por email;",
          "Google Ireland Ltd (Google Analytics), solo con tu consentimiento;",
          "Meta Platforms Ireland Ltd (Meta Pixel), solo con tu consentimiento.",
        ],
      },
      {
        title: "6. Transferencias fuera de la UE",
        paragraphs: [
          "Algunos de estos proveedores pueden tratar datos en Estados Unidos. En esos casos la transferencia se basa en el Marco de Privacidad de Datos UE-EE. UU., cuando el proveedor está adherido, o en las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea.",
        ],
      },
      {
        title: "7. Plazo de conservación",
        items: [
          "Solicitudes de contacto: el tiempo necesario para gestionar la solicitud y, en todo caso, no más de 24 meses desde el último contacto.",
          "Candidaturas: no más de 24 meses desde su recepción, salvo que solicites antes su supresión.",
          "Datos de navegación: el tiempo estrictamente necesario para la seguridad del sitio, salvo investigación de actividades ilícitas.",
          "Datos recogidos mediante cookies: según las duraciones indicadas en la Política de Cookies.",
        ],
      },
      {
        title: "8. Tus derechos",
        paragraphs: [
          "En cualquier momento puedes solicitar el acceso a tus datos, su rectificación, supresión, la limitación del tratamiento y la portabilidad, y puedes oponerte al tratamiento basado en el interés legítimo (arts. 15–22 RGPD). Puedes retirar tu consentimiento en cualquier momento, sin que ello afecte a la licitud del tratamiento previo a su retirada.",
          "Para ejercer tus derechos escribe a <b>info@qapex.it</b>. Si consideras que el tratamiento infringe el RGPD, puedes presentar una reclamación ante la autoridad italiana de protección de datos (www.garanteprivacy.it) o ante la autoridad de control de tu país.",
        ],
      },
      {
        title: "9. Enlaces (links) a sitios externos",
        paragraphs: [
          "Este sitio contiene hipervínculos (links), es decir, herramientas que permiten la conexión con páginas web de otros sitios: los sitios externos accesibles mediante enlaces son desarrollados y gestionados por sujetos sobre los que Qapex Srl no tiene ninguna titularidad ni control, y no es en modo alguno responsable de sus contenidos, calidad, exactitud y servicios ofrecidos. La visita y el uso de los sitios consultados por el usuario desde este sitio mediante enlaces quedan, por tanto, a la total discreción y responsabilidad del usuario.",
          "Por lo tanto, la presente información se facilita únicamente para el sitio Qapex.it y no para otros sitios web que el usuario pueda consultar mediante enlaces.",
        ],
      },
      {
        title: "10. Cambios",
        paragraphs: [
          "Podemos actualizar esta política. La versión vigente se publica siempre en esta página, con la fecha de la última actualización.",
        ],
      },
    ],
  },

  cookie: {
    title: "Política de Cookies",
    intro:
      "Las cookies son pequeños archivos de texto que un sitio web guarda en tu dispositivo. Esta página explica qué cookies y tecnologías similares (como el local storage) utiliza qapex.it y cómo puedes gestionarlas.",
    sections: [
      {
        title: "1. Herramientas técnicas (siempre activas)",
        paragraphs: [
          "Son necesarias para el funcionamiento del sitio y no requieren consentimiento.",
        ],
        items: [
          "<b>qapex_cookie_consent</b> (local storage, Qapex): guarda tu elección sobre las cookies. Duración: 12 meses.",
          "<b>Google Fonts</b> (Google): proporciona las tipografías del sitio. No instala cookies, pero recibe la dirección IP del navegador para enviar los archivos.",
        ],
      },
      {
        title: "2. Cookies de medición y marketing (solo con consentimiento)",
        paragraphs: [
          "Solo se activan si haces clic en \"Aceptar\" en el banner.",
        ],
        items: [
          "<b>Google Analytics 4</b> (Google Ireland Ltd): mide de forma agregada las visitas al sitio, las páginas vistas y la procedencia de los visitantes. Cookies: _ga (2 años), _ga_D13SGH4CKN (2 años). Política de privacidad: policies.google.com/privacy.",
          "<b>Meta Pixel</b> (Meta Platforms Ireland Ltd): mide las visitas procedentes de las campañas publicitarias en Facebook e Instagram y permite mostrar anuncios relevantes. Cookies: _fbp (3 meses), fr (3 meses). Política de privacidad: www.facebook.com/privacy/policy.",
        ],
      },
      {
        title: "3. Cómo gestionar el consentimiento",
        paragraphs: [
          "En tu primera visita puedes aceptar o rechazar las cookies de medición y marketing desde el banner. Puedes cambiar de opinión en cualquier momento con el botón \"Preferencias de cookies\" al final de esta página. También puedes eliminar o bloquear las cookies desde la configuración de tu navegador.",
          "Para todo lo demás (responsable, derechos, contactos) consulta la Política de Privacidad.",
        ],
      },
    ],
  },

  banner: {
    text:
      "Nosotros (qapex.it) y terceros seleccionados (3) utilizamos cookies o tecnologías similares con fines técnicos y, con tu consentimiento, también para fines de <b>funcionalidad, experiencia, medición y “marketing (con anuncios personalizados)”</b> como se especifica en la <link>política de cookies</link>.",
    text2:
      "Puedes dar, denegar o retirar libremente tu consentimiento en cualquier momento accediendo al panel de preferencias. Denegar el consentimiento puede hacer que las funciones relacionadas no estén disponibles.",
    text3: "Usa el botón “Aceptar” para dar tu consentimiento. Usa el botón “Rechazar” para continuar sin aceptar.",
    customize: "Más información y personalizar",
    necessaryTitle: "Necesarias",
    necessaryText: "Herramientas imprescindibles para el funcionamiento del sitio, como guardar tus preferencias de cookies.",
    alwaysOn: "Siempre activas",
    marketingTitle: "Medición y marketing",
    marketingText: "Google Analytics: mide de forma agregada las visitas al sitio. Meta Pixel: mide las visitas procedentes de nuestras campañas en Facebook e Instagram y permite mostrar anuncios personalizados.",
    save: "Guardar y continuar",
    accept: "Aceptar",
    reject: "Rechazar",
    settings: "Preferencias de cookies",
  },
};

export default legal;
